/**
 * OrderOrderPresenter
 * --
 */
import React, { useRef, useState } from 'react';
import {
  Content,
  Row,
  Col,
  Title,
  Breadcrumb,
  Button,
  Text,
  Image,
  ModalLayout,
  ScrollLayout,
  KakaoMap,
  Collapse,
  HtmlContent,
} from 'components';
import {
  Checkbox,
  DatePicker,
  Empty,
  InputNumber,
  Radio,
  Spin,
  Image as Img,
  Button as AntButton,
  Flex,
} from 'antd';
import {
  calculateRentalMonthlyPayment,
  STORE_URL,
  stringToMoneyFormat,
} from 'utils';
import Formatter from 'utils/Formatter';
import { PlusCircleFilled, DeleteOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import SHOPPING from 'assets/svg/shopping.svg';
import Calculate from 'utils/Calculate';
import { AddressInfo } from './components';

const DATE_FORMAT = 'YYYY/MM/DD';

const PAYMENT_METHOD = [
  {
    label: '신용카드',
    value: '1000000000000',
    method: 'CARD',
  },
  {
    label: '네이버페이',
    value: '0000000000001',
    type: 'secondary',
    method: 'NAVER_PAY',
  },
  {
    label: '카카오페이',
    value: '0000000010000',
    type: 'secondary',
    method: 'KAKAO_PAY',
  },
  // {
  //   label: '계좌이체',
  //   value: '0010000000000',
  //   type: 'secondary',
  //   method: 'TRANSFER',
  // },
  // {
  //   label: '무통장 입금',
  //   value: '0100000000000',
  //   type: 'secondary',
  //   method: 'VIRTUAL_ACCOUNT',
  // },
  // {
  //   label: '휴대폰 결제',
  //   value: '0000010000000',
  //   type: 'secondary',
  //   method: 'MOBILE',
  // },
  // TODO
  {
    label: 'JM 페이',
    value: 'JM_PAY',
    type: 'secondary',
    method: 'JM_PAY',
  },
];

const STORE_PICKUP_INFO = [
  '선택하신 수령지의 상황에 따라 픽업 준비 기간이 1~5일 더 소요될 수 있습니다.',
  '상품이 준비되면 상품별로 픽업준비완료 알림톡(SMS) 메시지를 보내드립니다. 메시지 확인 후 수령지에 방문하시기 바랍니다.\n(메시지 수신 전 픽업 불가)',
  '여러 개의 상품을 주문하실 경우 상품별로 준비기간이 다를 수 있습니다.',
  '픽업가능기간 내에 상품을 픽업하지 않으실 경우 주문 취소됩니다.',
];

const RENTAL_INFO = [
  // '렌탈료 할인 정책 및 판매자 정책 변동에 따라 렌탈료 결제금액이 달라질 수 있습니다.',
  // '판매자가 설정한 순서대로 할인이 적용되며, 각각 이전 단계의 할인가를 기준으로 계산됩니다.',
  // '렌탈료 청구 방식은 판매자 설정에 따라 결정됩니다.',
  // '계약자 명의변경, 양도양수가 불가합니다.',
  '계약기간은 기본 36개월이며, 매월 원두 정기구매 조건이 포함됩니다.',
  '설치비는 기본 무료이나 특수 설치 시 추가 비용이 발생할 수 있습니다.',
  '등록비 및 월 렌탈료는 카드 자동결제로 진행되며, 연체 시 연체료가 부과됩니다.',
  '정기점검 및 A/S는 계약 조건에 따라 제공되며, 고객 과실 시 유상 처리됩니다.',
  '계약 중도 해지 시 위약금 및 철거비가 발생하며, 분실 시 분실료가 청구됩니다.',
  '고객은 상품 임의 이전, 개조, 양도가 금지되며, 회사는 관리 목적의 확인 권한을 가집니다.',
  '고객정보 변경 시 즉시 회사에 통보해야 하며, 미통보 시 불이익은 고객 책임입니다.',
  '원두 가격은 시장 상황에 따라 변동될 수 있으며, 사전 통지 후 적용됩니다.',
  '렌탈서비스 이용약관 전문 보기 및 동의는 아래 링크를 반드시 확인 후 주문해 주세요.',
  '<a href="https://mall.jmcoffeemall.com/#/policy/rental">[약관 전문 보기]</a>',
];

const REFUND_INFO = [
  // '원두, 드립백 커피 등의 식품 특성상 단순 변심으로 인한 환불 및 교환은 불가합니다.',
  // '개봉 여부와 관계없이, 한 번 배송된 제품은 재판매가 불가하므로 교환 및 반품이 불가능합니다.',
  // '단, 제품의 이상이 확인된 경우(오배송, 파손, 품질 이상)에는 수령 후 7일 이내 고객센터로 문의해 주시면 교환 또는 환불이 가능합니다.',
  // '신선식품 및 냉동·냉장 제품은 보관 상태에 따라 품질이 변할 수 있어 단순 변심으로 인한 환불 및 교환이 절대 불가합니다.',
  // '제품이 배송 중 파손되었거나, 변질된 경우에는 수령 즉시 개봉 사진 및 상태를 고객센터로 접수해 주셔야 처리가 가능합니다.',
  // '반송이 필요한 경우 반드시 냉장·냉동 포장을 유지한 상태로 보내주셔야 합니다.',
  // '환불이 불가능한 경우에도 제품 이상이 의심될 경우, 수령 즉시 고객센터로 연락 주시면 최대한 도움을 드리겠습니다.',
  '원두는 식품으로 단순 변심에 의한 환불·교환이 불가하며, 제품 하자 시 수령 후 7일 이내 고객센터 접수 시 처리됩니다.',
  '렌탈 머신은 계약 기간 중 중도 해지 시 위약금 및 철거비가 발생하며, 제품 하자인 경우 무상 A/S 또는 교환이 가능합니다.',
  '환불은 등록 카드 기준으로만 진행되며, 결제 월의 환불은 익월부터 가능합니다.',
  '자세한 내용은 환불 및 교환 약관 전문 보기를 꼭 확인해 주세요.',
  '<a href="https://mall.jmcoffeemall.com/#/policy/refund">[약관 전문 보기]</a>',
];

const RATE_TYPE = {
  R: '%',
  W: '원',
};

const OrderOrderPresenter = (props) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  const {
    orderList,
    deliveryAddress,
    selectedDelivery,
    paymentInfo,
    setSelectedDelivery,
    onPayment,
    user,
    onOpenPopup,
    onDeleteAddress,
    isLoading,
    setIsLoading,
    setPaymentMethod,
    coupons,
    selectedCoupon,
    setSelectedCoupon,
    selectedProduct,
    setSelectedProduct,
    onApplyCoupon,
    type,
    cardList,
    onOpenCardPopup,
    selectedCard,
    setSelectedCard,
    deliveryDate,
    setDeliveryDate,
    minDeliveryDate,
    point,
    usePoint,
    setUsePoint,
    isChecked,
    setIsChecked,
    isAgree,
    setIsAgree,
    screenSize,
    paymentType,
    maxUseablePoint,
    isRefundNotAllowed,
    isRefundAgree,
    setIsRefundAgree,
    onDeleteCard,
    today,
  } = props;

  /* ===== STATE ===== */
  const titleRef = useRef(null);
  const [top, setTop] = useState(0);
  // 쿠폰 모달
  const [isDrawer, setIsDrawer] = React.useState(false);
  // 쿠폰 목록
  const [couponList, setCouponList] = React.useState([]);
  // 사용 가능 쿠폰 목록
  const [drawerCoupon, setDrawerCoupon] = React.useState([]);
  // 결제수단
  // const [selectedPaymentMethod, setSelectedPaymentMethod] = React.useState(
  //   PAYMENT_METHOD[0].value
  // );
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);

  const handleChange = (value) => {
    setSelectedPaymentMethod(value);
    const selectedMethod = PAYMENT_METHOD.find(
      (method) => method.value === value
    );
    setPaymentMethod(selectedMethod?.method);
  };

  const [isPickupModal, setIsPickupModal] = React.useState(null);
  const [mapKey, setMapKey] = React.useState('MAP');

  /* ===== VARIABLE ===== */
  const styles = {
    titleLayout: {
      paddingBottom: 20,
      borderBottom: '4px solid var(--black-color)',
      display: 'flex',
      flexDirection: screenSize >= 768 ? 'unset' : 'column',
      justifyContent: 'space-between',
      alignItems: screenSize >= 768 ? 'center' : 'start',
    },

    title: {
      fontSize: screenSize >= 768 ? 28 : 24,
      fontWeight: 400,
      fontFamily: `${'Dela Gothic One'}, sans-serif`,
      lineHeight: '180%',
      textTransform: 'capitalize',
    },
    subTitle: {
      fontSize: screenSize >= 768 ? 28 : 20,
      fontWeight: 700,
      color: 'var(--black-color)',
      paddingBottom: 20,
      borderBottom: '2px solid var(--black-color)',
    },
    imageRatio: {
      width: '100%',
      height: 'auto',
      aspectRatio: '4 / 5',
      objectFit: 'cover',
      // display: 'block',
      overflow: 'hidden',
    },

    orderButton: {
      width: '100%',
      height: screenSize >= 1200 ? 80 : screenSize >= 768 ? 60 : 45,
      borderRadius: 0,
      fontSize: screenSize >= 1200 ? 28 : screenSize >= 768 ? 20 : 16,
    },
    checkbox: {
      fontSize: 14,
      color: 'var(--black-color)',
    },
    orderInfo: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: screenSize >= 768 ? 16 : 10,
    },
    orderInfoText: {
      fontSize: screenSize >= 768 ? 16 : 14,
    },

    button: {
      width: '100%',
      height: screenSize >= 768 ? 84 : 50,
      fontSize: screenSize >= 768 ? 18 : 14,
      padding: screenSize >= 768 ? ' 4px 16px' : '4px',
      fontWeight: 700,
      borderRadius: 0,
    },

    form: {
      display: 'flex',
      flexDirection: screenSize >= 768 ? 'unset' : 'column',
      marginBottom: 24,
    },
    label: {
      width: 137,
      minHeight: 52,
      display: 'flex',
      alignItems: 'center',
      fontSize: 16,
      fontWeight: 400,
      paddingRight: 16,
      whiteSpace: 'nowrap',
    },
    inputArea: {
      minHeight: 52,
      display: 'flex',
      alignItems: 'center',
    },
    formButton: {
      width: 137,
      height: 44,
      borderRadius: 0,
      fontSize: 16,
      fontWeight: 700,
    },
    input: {
      small: {
        height: 44,
        width: 290,
        fontSize: 14,
      },
      medium: {
        height: 44,
        width: screenSize >= 1200 ? 443 : 330,
        fontSize: 14,
      },
      large: {
        height: 44,
        width: 596,
        fontSize: 14,
      },
    },

    modalButton: {
      border: '1px solid #EEEEEE',
      borderRadius: 5,
      background: 'none',
      padding: '2px 5px',
      cursor: 'pointer',
      display: 'inline-block',
    },

    cardLayout: {
      width: screenSize >= 768 ? 360 : 260,
      height: screenSize >= 768 ? 205 : 150,
      borderRadius: 10,
      padding: 20,
      cursor: 'pointer',
      margin: 5,
    },
  };

  const breadcrumb = [
    {
      key: 'shopping bag',
      title: 'SHOPPING BAG',
    },
    {
      key: 'order',
      title: 'ORDER',
    },
    {
      key: 'order confirmed',
      title: 'ORDER CONFIRMED',
    },
  ];

  /* ===== FUNCTION ===== */
  /**
   * 사용 가능 쿠폰 정제
   * --
   */
  const getUseAbleCoupon = React.useCallback(
    (product) => {
      setIsLoading(true);

      const newCouponList = couponList.map((coupon) => {
        const { policy_coupon } = coupon;

        // 상품 원가 + 옵션가
        const productOriginTotalPrice = product?.price + product.option_price;
        // 등급 할인 금액
        const productGradeDiscountPrice =
          product?.grade_discount_price / product?.cart_num;
        // 프로모션 할인 금액
        const productPromotionDiscountPrice =
          product?.promotion_discount_price / product?.cart_num;

        // 쿠폰은 하나의 상품에만 적용됨
        const standardPrice =
          policy_coupon.is_duplication === 'Y'
            ? productOriginTotalPrice -
              productGradeDiscountPrice -
              productPromotionDiscountPrice
            : productOriginTotalPrice - productGradeDiscountPrice;

        // SECTION: 쿠폰 할인금
        const { discount, reserve } = Calculate.calculateDiscountReserve(
          standardPrice,
          product?.cart_num,
          policy_coupon
        );

        return {
          ...coupon,
          discount_price: discount,
          reserve_price: reserve,
          policy_coupon: {
            ...policy_coupon,
            discount_price: discount,
            reserve_price: reserve,
          },
        };
      });

      // 쿠폰 사용 가능 여부 체크
      const newMyCouponData = newCouponList.map((coupon) => {
        // SECTION: 사용 불가능 업체 체크
        const disabledShop = coupon.policy_coupon.disabled_shop;
        const isDisabledShop = disabledShop
          ? disabledShop.some(
              (shop) => shop.shop_information_id === product.shop_information_id
            )
          : false;

        if (isDisabledShop) {
          return {
            ...coupon,
            is_available: 'SHOP',
          };
        }

        // SECTION: 적용가능 상품
        const availableProduct = coupon.map_product_policy;
        const isPossibleProduct = !availableProduct.some(
          (policy) => policy.product_id === product.product_id
        );

        if (isPossibleProduct) {
          return {
            ...coupon,
            is_available: 'PRODUCT',
          };
        }

        // SECTION: 사용일 이전인지 체크
        const startDate = coupon.policy_coupon.start_date;

        if (startDate && startDate > today) {
          return {
            ...coupon,
            is_available: 'PREV',
          };
        }

        // SECTION: 최소 사용 가능 금액 이상인지 여부
        const minimumPrice = coupon.policy_coupon.minimum_price;
        if (minimumPrice > product.final_price) {
          return {
            ...coupon,
            is_available: 'PRICE',
          };
        }

        // SECTION: 적용중인 쿠폰인지 여부 체크
        const applyProduct = coupon.apply_product;
        if (applyProduct && applyProduct.key !== product.key) {
          return {
            ...coupon,
            is_available: 'APPLY',
          };
        }

        return {
          ...coupon,
          is_available: 'DONE',
        };
      });

      // 사용 가능한 순서로 정렬 (DONE -> APPLY -> PRICE -> PREV -> MENU -> SHOP)
      const sortedCoupons = newMyCouponData
        ?.sort((a, b) => b.discount_price - a.discount_price)
        ?.sort((a, b) => {
          const priority = {
            DONE: 0,
            APPLY: 1,
            PRICE: 2,
            PREV: 3,
            PRODUCT: 4,
            SHOP: 5,
          };

          return priority[a.is_available] - priority[b.is_available];
        });

      setSelectedProduct(product);
      setDrawerCoupon(sortedCoupons);

      setTimeout(() => {
        setIsLoading(false);
        setIsDrawer(true);
      }, 300);
    },
    // eslint-disable-next-line
    [coupons, paymentInfo]
  );

  /**
   * 쿠폰 모달 닫기
   * --
   */
  const drawerClose = (product, coupon = null) => {
    if (product && coupon) {
      const newCoupon = { ...coupon, apply_product: product };

      const fid = couponList.findIndex(
        (cou) => cou.coupon_user_id === coupon.coupon_user_id
      );

      const applyCoupon = couponList.findIndex(
        (cou) => cou?.apply_product?.key === product.key
      );

      if (applyCoupon === -1) {
        setCouponList((prev) => [
          ...prev.slice(0, fid),
          newCoupon,
          ...prev.slice(fid + 1),
        ]);
      } else {
        const newList = couponList.map((cou, index) => {
          const d =
            fid === index
              ? newCoupon
              : applyCoupon === index
              ? { ...cou, apply_product: null }
              : cou;

          return d;
        });

        setCouponList(newList);
      }
    } else if (product && !coupon) {
      const fid = couponList.findIndex(
        (cou) => cou?.apply_product?.key === product?.key
      );

      setCouponList((prev) => [
        ...prev.slice(0, fid),
        { ...prev[fid], apply_product: null },
        ...prev.slice(fid + 1),
      ]);
    }

    setIsDrawer(!isDrawer);
    setDrawerCoupon([]);
    setSelectedCoupon(null);
    setSelectedProduct(null);
  };

  /**
   * 적용 쿠폰 선택
   * --
   * @param {object} coupon
   */
  const handleCouponClick = (coupon) => {
    if (
      selectedCoupon &&
      selectedCoupon.coupon_user_id === coupon.coupon_user_id
    ) {
      setSelectedCoupon(null); // 쿠폰 해제
    } else {
      setSelectedCoupon(coupon); // 쿠폰 선택
    }
  };

  /**
   * 쿠폰 사용 불가 사유
   * --
   * @param {string} type
   * @param {object} coupon
   * @returns
   */
  const getReason = (type, coupon) => {
    const REASON = {
      PREV: `${dayjs
        .unix(coupon.policy_coupon.start_date)
        .format('YYYY년 MM월 DD일 이후 사용가능')}`,
      SHOP: '쿠폰을 사용할 수 없는 업체입니다.',
      PRODUCT: '적용 가능한 상품이 아닙니다.',
      PRICE: `${stringToMoneyFormat(
        coupon.policy_coupon.minimum_price,
        '원'
      )} 이상 구매 시 사용가능합니다.`,
      APPLY: '다른 상품에 적용중입니다.',
    };

    return REASON[type];
  };

  /* ===== HOOKS ===== */
  /**
   * 타이틀 높이
   * --
   */
  React.useEffect(() => {
    if (titleRef.current) {
      const h = titleRef.current.clientHeight;

      setTop(h);
    }
  }, []);

  /**
   * 기본 배송지
   * --
   */
  React.useEffect(() => {
    if (deliveryAddress) {
      setSelectedDelivery(deliveryAddress[0]);
    }
    // eslint-disable-next-line
  }, []);

  /**
   * 쿠폰 목록 정제
   * --
   */
  React.useEffect(() => {
    if (!coupons.length || coupons.length === couponList) return;

    const newCouponList = coupons.map((coupon) => ({
      ...coupon,
      apply_product: null,
    }));

    setCouponList(newCouponList);
    // eslint-disable-next-line
  }, [coupons]);

  /**
   * 결제 금액 변동 시 사용 포인트 재제한
   * --
   */
  React.useEffect(() => {
    const ratio = maxUseablePoint / 100;
    if (
      usePoint &&
      usePoint > Math.floor(paymentInfo.total_product_price * ratio)
    ) {
      setUsePoint(paymentInfo.total_product_price * ratio);
    }
    // eslint-disable-next-line
  }, [paymentInfo.total_product_price, maxUseablePoint]);

  React.useEffect(() => {
    if (type === 'delivery' && selectedCard) {
      setSelectedPaymentMethod('QUICK_CARD');
    }
    // eslint-disable-next-line
  }, [type, selectedCard]);

  React.useEffect(() => {
    if (selectedPaymentMethod !== 'QUICK_CARD') {
      setSelectedCard(null);
    }
    // eslint-disable-next-line
  }, [selectedPaymentMethod]);

  React.useEffect(() => {
    if (!paymentType) return;

    const findType = PAYMENT_METHOD.find(
      (method) => method?.method === paymentType?.toLocaleUpperCase()
    );

    setSelectedPaymentMethod(findType?.value);
  }, [paymentType]);

  /* ===== RENDER ===== */
  return (
    <React.Fragment>
      <Spin spinning={isLoading}>
        <Content
          maxWidth={1820}
          padding={screenSize >= 768 ? '130px 0px' : '80px 0'}
        >
          <Row gutter={16}>
            <Col x={0} md={1} xl={2}></Col>
            <Col x={24} md={22} xl={20}>
              <div
                style={{
                  ...styles.titleLayout,
                }}
              >
                <Title style={{ ...styles.title }}>shopping bag</Title>

                <Breadcrumb
                  items={breadcrumb}
                  separator={'>'}
                  itemStyle={{
                    color: 'var(--light-gray-color)',
                    fontFamily: `${'Dela Gothic One'}, sans-serif`,
                  }}
                  activeKey={'order'}
                  activeColor={'var(--black-color)'}
                  separatorStyle={{ color: 'var(--light-gray-color)' }}
                  style={{
                    flexDirection: screenSize >= 768 ? 'unset' : 'column',
                    alignItems: screenSize >= 768 ? 'center' : 'start',
                    marginTop: screenSize >= 768 ? 0 : 20,
                    rowGap: screenSize >= 768 ? 0 : 10,
                  }}
                />
              </div>
            </Col>
            <Col x={0} md={1} xl={2}></Col>
          </Row>

          <Row gutter={16} style={{ marginTop: 100 }}>
            <Col x={0} md={1} xl={2}></Col>
            <Col x={24} md={14} xl={14}>
              {/* 배송지 정보 */}
              {type !== 'store_pickup' ? (
                <div>
                  <div ref={titleRef}>
                    <Title style={{ ...styles.subTitle }}>배송지 정보</Title>
                  </div>

                  <AddressInfo
                    styles={styles}
                    selectedDelivery={selectedDelivery}
                    onSelect={setSelectedDelivery}
                    deliveryAddress={deliveryAddress}
                    onOpen={onOpenPopup}
                    onDelete={onDeleteAddress}
                    user={user}
                  />
                </div>
              ) : null}
              {/* 배송지 정보 끝 */}

              {/* 택배 배송 */}
              <div style={{ marginTop: type !== 'store_pickup' ? 80 : 0 }}>
                <Title style={{ ...styles.subTitle }}>상품</Title>

                {orderList?.map((order) => (
                  <Content
                    key={`forward-product-${order.forwarding_location_id}`}
                    maxWidth={'100%'}
                    padding={'20px 0px'}
                    style={{
                      borderBottom: '1px solid var(--light-gray-color)',
                      display: 'flex',
                      flexDirection: 'column',
                    }}
                  >
                    <Flex
                      gap={screenSize >= 768 ? 30 : 15}
                      style={{
                        overflowX: 'scroll',
                      }}
                    >
                      {order?.product_information?.map((product) => (
                        <div
                          key={`product-${product.key}-${product.product_id}`}
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            rowGap: 10,
                            width: 245,
                            minWidth: screenSize >= 768 ? 245 : 200,
                          }}
                        >
                          <Image
                            src={product.thumbnail}
                            style={styles.imageRatio}
                            alt={product.product_name}
                          />
                          <div
                            style={{
                              paddingLeft: 0,
                              display: 'flex',
                              flexDirection: 'column',
                              justifyContent: 'space-between',
                              alignItems: 'flex-start',
                              flex: 1,
                              rowGap: 10,
                            }}
                          >
                            <div>
                              <Text
                                size={screenSize >= 768 ? 16 : 14}
                                style={{ paddingTop: 6 }}
                                weight={700}
                                color={'#666666'}
                              >
                                {product.shop_information_name}
                              </Text>
                              <Text
                                size={screenSize >= 768 ? 18 : 16}
                                weight={700}
                                style={{
                                  paddingTop: 8,
                                  webkitBoxOrient: 'unset',
                                  overflow: 'unset',
                                  wordBreak: 'keep-all',
                                  textOverflow: 'unset',
                                }}
                              >
                                {product.product_name}
                              </Text>
                              {product.product_option &&
                              product.product_option.length ? (
                                <Text size={14} style={{ paddingTop: 16 }}>
                                  옵션 :{' '}
                                  {product.product_option
                                    .map((cur) =>
                                      cur.option
                                        .map((op) => op.option_name)
                                        .join(' / ')
                                    )
                                    .join(' / ')}
                                </Text>
                              ) : null}
                              {type !== 'rental' ? (
                                <div
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    flexWrap: 'wrap',
                                    paddingTop: 8,
                                    gap: 4,
                                  }}
                                >
                                  <Text size={14}>
                                    {stringToMoneyFormat(
                                      product.price + product.option_price,
                                      '원 '
                                    )}
                                  </Text>
                                  <Text size={14}>/</Text>
                                  <Text size={14}>
                                    수량{' '}
                                    {stringToMoneyFormat(
                                      product.cart_num,
                                      '개'
                                    )}
                                  </Text>
                                  {product?.grade_discount_price ||
                                  product?.promotion_discount_price ? (
                                    <Text
                                      size={14}
                                      color={'var(--danger-color)'}
                                      style={{ paddingLeft: 4 }}
                                    >
                                      할인가 :{' '}
                                      {stringToMoneyFormat(
                                        product?.product_final_price,
                                        '원'
                                      )}
                                    </Text>
                                  ) : null}
                                </div>
                              ) : (
                                <div style={{ marginTop: 10 }}>
                                  <ul
                                    style={{
                                      display: 'flex',
                                      gap: 4,
                                      alignItems: 'center',
                                      flexWrap: 'wrap',
                                    }}
                                  >
                                    <li>
                                      <Text size={14} weight={700}>
                                        <span
                                          style={{
                                            paddingRight: 4,
                                            fontWeight: 400,
                                            fontSize: 12,
                                          }}
                                        >
                                          계약기간
                                        </span>
                                        {
                                          product?.rental_option?.contract_date
                                            ?.option_value
                                        }
                                        개월
                                      </Text>
                                    </li>
                                    <li style={{ fontSize: 12 }}>/</li>
                                    <li>
                                      <Text size={14} weight={700}>
                                        <span
                                          style={{
                                            paddingRight: 4,
                                            fontWeight: 400,
                                            fontSize: 12,
                                          }}
                                        >
                                          의무사용기간
                                        </span>
                                        {
                                          product?.rental_option?.contract_date
                                            ?.mandatory_usage_date?.option_value
                                        }
                                        개월
                                      </Text>
                                    </li>
                                    <li style={{ fontSize: 12 }}>/</li>
                                    <li>
                                      <Text size={14} weight={700}>
                                        <span
                                          style={{
                                            paddingRight: 4,
                                            fontWeight: 400,
                                            fontSize: 12,
                                          }}
                                        >
                                          선납입금
                                        </span>
                                        {stringToMoneyFormat(
                                          product?.rental_option?.advance_price
                                            ?.option_value
                                        )}
                                        원
                                      </Text>
                                    </li>
                                    <li style={{ fontSize: 12 }}>/</li>
                                    <li>
                                      <Text size={14} weight={700}>
                                        <span
                                          style={{
                                            paddingRight: 4,
                                            fontWeight: 400,
                                            fontSize: 12,
                                          }}
                                        >
                                          관리유형
                                        </span>
                                        {
                                          product?.rental_option?.management
                                            ?.option_name
                                        }
                                      </Text>
                                    </li>
                                    <li style={{ fontSize: 12 }}>/</li>
                                    <li>
                                      <Text size={14} weight={700}>
                                        <span
                                          style={{
                                            paddingRight: 4,
                                            fontWeight: 400,
                                            fontSize: 12,
                                          }}
                                        >
                                          추가금
                                        </span>
                                        {`${
                                          product?.rental_option
                                            ?.additional_cost?.option_name
                                        } (+ ${stringToMoneyFormat(
                                          product?.rental_option
                                            ?.additional_cost?.option_price
                                        )})`}
                                      </Text>
                                    </li>
                                  </ul>
                                </div>
                              )}
                            </div>

                            <div
                              style={{
                                width: '100%',
                                marginTop: product.coupon_info ? 20 : 0,
                              }}
                            >
                              <Flex align="flex-end">
                                <Flex
                                  gap={10}
                                  flex={1}
                                  style={{
                                    position: 'relative',
                                    top: 0,
                                    left: 0,
                                    flex: 1,
                                  }}
                                >
                                  <Text
                                    size={screenSize >= 768 ? 18 : 16}
                                    weight={700}
                                  >
                                    결제금액:
                                  </Text>
                                  <Text
                                    size={screenSize >= 768 ? 18 : 16}
                                    weight={700}
                                    style={{
                                      textDecoration: product.coupon_info
                                        ? 'line-through'
                                        : 'none',
                                    }}
                                  >
                                    {type !== 'rental'
                                      ? stringToMoneyFormat(
                                          product?.product_final_price *
                                            product?.cart_num,
                                          '원'
                                        )
                                      : stringToMoneyFormat(
                                          product?.product_final_price *
                                            product?.cart_num +
                                            (paymentInfo?.additional_cost ?? 0),
                                          '원'
                                        )}
                                  </Text>

                                  {product.coupon_info ? (
                                    <div
                                      style={{
                                        position: 'absolute',
                                        bottom: '80%',
                                        left: 30,
                                      }}
                                    >
                                      <Text
                                        size={16}
                                        weight={700}
                                        color={'var(--danger-color)'}
                                        style={{ paddingLeft: 4 }}
                                      >
                                        쿠폰적용가{' '}
                                        {type !== 'rental'
                                          ? stringToMoneyFormat(
                                              product.origin_total_price *
                                                product.cart_num -
                                                product.total_discount_price,
                                              '원'
                                            )
                                          : stringToMoneyFormat(
                                              calculateRentalMonthlyPayment(
                                                product.origin_total_price *
                                                  product.cart_num -
                                                  product.total_discount_price,
                                                product?.rental_option
                                              ),
                                              '원'
                                            )}
                                      </Text>
                                    </div>
                                  ) : null}
                                </Flex>
                              </Flex>
                              {type !== 'rental' ? (
                                <Button
                                  type="secondary"
                                  style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    width: '100%',
                                    borderRadius: 5,
                                    fontSize: 12,
                                    fontWeight: 700,
                                    marginTop: 10,
                                  }}
                                  onClick={() => getUseAbleCoupon(product)}
                                >
                                  {product.coupon_info
                                    ? '쿠폰 변경'
                                    : '쿠폰 사용'}
                                </Button>
                              ) : null}
                            </div>
                          </div>
                        </div>
                      ))}
                    </Flex>

                    {type === 'store_pickup' ? (
                      <div
                        style={{
                          width: '100%',
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'space-between',
                          //alignItems: 'center',
                          gap: 10,
                          borderTop: '1px solid #EEEEEE',
                          paddingTop: 20,
                          marginTop: 20,
                        }}
                      >
                        <div
                          style={{
                            flex: 1,
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 10,
                          }}
                        >
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: 8,
                            }}
                          >
                            <img
                              src={SHOPPING}
                              alt="매장"
                              style={{ width: 32 }}
                            />
                            <Text size={18} weight={700}>
                              {order?.forwarding_location?.forwarding_name}
                            </Text>
                          </div>

                          <div>
                            <Text
                              size={16}
                              color={'var(--light-gray-color)'}
                              style={{ webkitLineClamp: 'unset' }}
                            >
                              {order?.forwarding_location?.forwarding_address},{' '}
                              {
                                order?.forwarding_location
                                  ?.forwarding_address_detail
                              }
                            </Text>
                          </div>

                          <ul
                            style={{
                              display: 'flex',
                              flexWrap: 'wrap',
                              alignItems: 'center',
                              gap: 10,
                            }}
                          >
                            <li
                              style={{
                                display: 'flex',
                                //alignItems: 'center',
                                gap: 10,
                                //flexDirection: 'column',
                              }}
                            >
                              <Text weight={700}>대표연락처</Text>
                              <Text color={'#666666'}>
                                {order?.forwarding_location?.phone}
                              </Text>
                            </li>
                            {/* <li>
                              <Text size={12}>|</Text>
                            </li> */}

                            <li
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 10,
                              }}
                            >
                              <Text weight={700}>영업시간</Text>
                              <Text color={'#666666'}>
                                {
                                  order?.forwarding_location
                                    ?.receive_information?.business_hour
                                }
                              </Text>
                            </li>
                          </ul>

                          <Text
                            size={12}
                            color={'#D33444'}
                            style={{ webkitLineClamp: 'unset' }}
                          >
                            픽업지별로 픽업가능시간, 재고가 상이할 수 있으니
                            결제 전 유선통화 확인을 권장드립니다.
                          </Text>
                        </div>

                        <div>
                          <Button
                            style={{ borderRadius: 0 }}
                            type="secondary"
                            onClick={() =>
                              setIsPickupModal(order?.forwarding_location)
                            }
                          >
                            지도보기
                          </Button>
                        </div>
                      </div>
                    ) : null}
                  </Content>
                ))}
              </div>
              {/* 택배 배송 끝 */}

              {/* 쿠폰 & 포인트 */}
              {type !== 'rental' ? (
                <div style={{ marginTop: 80 }}>
                  <Title style={{ ...styles.subTitle }}>포인트</Title>

                  <Content
                    maxWidth={'100%'}
                    padding={'20px 0px'}
                    style={{
                      borderBottom: '1px solid var(--light-gray-color)',
                    }}
                  >
                    <ul>
                      {/* <li style={{ ...styles.form }}>
                        <div style={{ ...styles.label }}>사용 가능 쿠폰</div>
                        <div>
                          <div style={{ ...styles.inputArea }}>
                            <Select
                              placeholder="쿠폰 선택"
                              style={{ ...styles.input.medium }}
                            />
                          </div>
                        </div>
                      </li> */}

                      <li style={{ ...styles.form, marginBottom: 0 }}>
                        <div style={{ ...styles.label }}>보유 적립금 사용</div>
                        <div>
                          <div style={{ ...styles.inputArea }}>
                            <InputNumber
                              placeholder="0"
                              value={usePoint ? usePoint : null}
                              style={{
                                ...styles.input.small,
                                marginRight: 16,
                                width: screenSize >= 1200 ? 'inherit' : '100%',
                              }}
                              onChange={(e) => setUsePoint(e)}
                              formatter={(value) =>
                                `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                              }
                              max={
                                paymentInfo.total_product_price *
                                  (maxUseablePoint / 100) >=
                                point
                                  ? Math.floor(point)
                                  : Math.floor(
                                      paymentInfo.total_product_price *
                                        (maxUseablePoint / 100)
                                    )
                              }
                              min={0}
                              controls={false}
                            />

                            <Button
                              style={{ ...styles.formButton }}
                              onClick={() =>
                                setUsePoint(
                                  paymentInfo.total_product_price *
                                    (maxUseablePoint / 100) >=
                                    point
                                    ? Math.floor(point)
                                    : Math.floor(
                                        paymentInfo.total_product_price *
                                          (maxUseablePoint / 100)
                                      )
                                )
                              }
                            >
                              전액 사용
                            </Button>
                          </div>
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: 5,
                            }}
                          >
                            <Text size={12}>적용한도({maxUseablePoint}%)</Text>
                            <Text size={12}>/</Text>
                            <Text size={12}>
                              보유 포인트: {stringToMoneyFormat(point)}
                            </Text>
                            <Text size={12}>/</Text>
                            <Text size={12}>
                              사용가능:{' '}
                              <span style={{ color: '#D33444' }}>
                                {stringToMoneyFormat(
                                  paymentInfo.total_product_price *
                                    (maxUseablePoint / 100) >=
                                    point
                                    ? Math.floor(point)
                                    : Math.floor(
                                        paymentInfo.total_product_price *
                                          (maxUseablePoint / 100)
                                      )
                                )}
                              </span>
                            </Text>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </Content>
                </div>
              ) : null}
              {/* 쿠폰 & 포인트 끝 */}

              {/* 정기배송/렌탈 시작일 */}
              {type === 'subscription' || type === 'rental' ? (
                <div style={{ marginTop: 80 }}>
                  <Title style={{ ...styles.subTitle }}>
                    {type === 'subscription' ? '정기배송 시작일' : '배송일'}
                  </Title>

                  <Content
                    maxWidth={'100%'}
                    padding={'20px 0px'}
                    style={{
                      borderBottom: '1px solid var(--light-gray-color)',
                    }}
                  >
                    <ul>
                      <li style={{ ...styles.form, alignItems: 'flex-start' }}>
                        <div style={{ ...styles.label }}>
                          {type === 'subscription' ? '배송시작일' : '배송일'}
                        </div>
                        <div>
                          <div style={{ ...styles.inputArea }}>
                            <DatePicker
                              placeholder={
                                type === 'subscription'
                                  ? '배송시작일 선택'
                                  : '배송일 선택'
                              }
                              style={{ ...styles.input.medium }}
                              format={DATE_FORMAT}
                              value={
                                deliveryDate
                                  ? dayjs(deliveryDate, DATE_FORMAT)
                                  : null
                              }
                              minDate={dayjs().add(minDeliveryDate, 'day')}
                              onChange={(_, dateString) =>
                                setDeliveryDate(dateString)
                              }
                            />
                          </div>
                          <Text size={13} color={'#D33444'}>
                            {type === 'subscription'
                              ? '(결제일: 첫 결제 이후 주기별 배송시작일의 1일전)'
                              : '(결제일: 첫 결제 이후 설치완료일 기준 1개월 주기)'}
                          </Text>
                        </div>
                      </li>
                    </ul>
                  </Content>
                </div>
              ) : null}
              {/* 정기배송 시작일 끝 */}

              {/* 결제수단 선택 */}
              <div style={{ marginTop: 80 }}>
                <Title style={{ ...styles.subTitle }}>결제수단 선택</Title>

                {/* 간편결제 등록 카드 */}
                <ScrollLayout direction={'horizontal'} scrollable>
                  <div
                    style={{
                      marginTop: 20,
                      display: 'flex',
                      alignItems: 'center',
                      gap: screenSize >= 768 ? 20 : 5,
                    }}
                  >
                    <div
                      style={{
                        ...styles.cardLayout,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        flexDirection: 'column',
                        cursor: 'pointer',
                        border: '1px solid #DDDDDD',
                        background: '#FFFFFF',
                        gap: 10,
                      }}
                      onClick={() =>
                        onOpenCardPopup(
                          type === 'delivery' ? 'quick_card' : type
                        )
                      }
                    >
                      <PlusCircleFilled style={{ fontSize: 24 }} />
                      <Text size={13} weight={700} color={'#999999'}>
                        카드 등록
                      </Text>
                    </div>
                    {cardList.map((card) => (
                      <div
                        key={`card-${card.card_id}`}
                        style={{
                          background:
                            selectedCard &&
                            selectedCard.card_id === card.card_id
                              ? '#111111'
                              : 'transparent',
                          borderRadius: 10,
                        }}
                        onClick={() => setSelectedCard(card)}
                      >
                        <div
                          style={{
                            ...styles.cardLayout,
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between',
                            background: '#595A5F',
                            position: 'relative',
                            top: 0,
                            left: 0,
                          }}
                        >
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              gap: 5,
                            }}
                          >
                            <Text size={20} color={'#FFFFFF'}>
                              {card.card_company}
                            </Text>
                            {type === 'delivery' ? (
                              <>
                                {' '}
                                <AntButton
                                  danger
                                  size="small"
                                  style={{
                                    border: 'none',
                                    position: 'absolute',
                                    top: 2,
                                    right: 2,
                                    background: '#595A5F',
                                  }}
                                  icon={<DeleteOutlined />}
                                  onClick={() => {
                                    onDeleteCard(card);
                                  }}
                                />
                              </>
                            ) : null}
                          </div>
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: 5,
                            }}
                          >
                            <Text size={13} color={'#FFFFFF'}>
                              {card.card_number}
                            </Text>
                            <Text size={11} color={'#FFFFFF'}>
                              |
                            </Text>
                            <Text size={13} color={'#FFFFFF'}>
                              {card.card_validity}
                            </Text>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </ScrollLayout>

                {/* PG결제 */}
                {type === 'delivery' || type === 'store_pickup' ? (
                  <Radio.Group
                    value={selectedPaymentMethod}
                    onChange={(e) => handleChange(e.target.value)}
                    style={{
                      display: 'flex',
                      flexDirection: screenSize >= 768 ? 'unset' : 'column',
                      flexWrap: 'wrap',
                      gap: screenSize >= 768 ? 50 : 10,
                      marginTop: 40,
                    }}
                  >
                    {PAYMENT_METHOD?.map((payment) => (
                      <div
                        key={`payment-method-${payment.value}`}
                        style={{
                          display: 'flex',
                          alignItems: 'baseline',
                          gap: 10,
                        }}
                      >
                        <Radio value={payment.value} />
                        <div
                          style={{
                            padding: screenSize >= 500 ? '10px 0px' : '5px 0',
                          }}
                        >
                          <span
                            style={{
                              fontSize: screenSize >= 500 ? 16 : 15,
                              fontWeight: 700,
                            }}
                          >
                            {payment.label}
                          </span>
                        </div>
                      </div>
                    ))}
                  </Radio.Group>
                ) : null}

                {/* 기존 버튼 형식 */}
                {/* {type === 'delivery' || type === 'store_pickup' ? (
                  <Row gutter={[20, 20]} style={{ marginTop: 20 }}>
                    {PAYMENT_METHOD?.map((payment) => (
                      <Col x={8}>
                        <Button
                          type={
                            selectedPaymentMethod === payment.value
                              ? 'primary'
                              : 'secondary'
                          }
                          style={{ ...styles.button }}
                          onClick={() => {
                            setSelectedPaymentMethod(payment.value);
                            setPaymentMethod(payment.method);
                          }}
                        >
                          {payment.label}
                        </Button>
                      </Col>
                    ))}
                  </Row>
                ) : null} */}
              </div>
              {/* 결제수단 선택 끝 */}

              {/* 주문동의 */}
              {type === 'store_pickup' || type === 'rental' ? (
                <div style={{ marginTop: 80 }}>
                  <Title style={{ ...styles.subTitle }}>주문동의</Title>
                  <div>
                    <Collapse
                      title={
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 10,
                            padding: 10,
                          }}
                        >
                          <Checkbox
                            checked={isAgree}
                            onClick={(e) => {
                              e.stopPropagation();
                              setIsAgree(e.target.checked);
                            }}
                          />
                          <Text color={'#D33444'}>[필수]</Text>
                          <Text>
                            {type === 'store_pickup'
                              ? '매장픽업 서비스 안내 사항'
                              : '렌탈 서비스 안내사항'}
                          </Text>
                        </div>
                      }
                      defaultOpened={true}
                    >
                      <Content
                        maxWidth={'100%'}
                        style={{
                          borderBottom: '1px solid var(--light-gray-color)',
                          display: 'flex',
                          flexDirection: 'column',
                          gap: 8,
                        }}
                      >
                        {(type === 'store_pickup'
                          ? STORE_PICKUP_INFO
                          : RENTAL_INFO
                        ).map((item) => (
                          <div style={{ display: 'flex' }}>
                            <Text size={12} color={'#666666'}>
                              •
                            </Text>
                            <HtmlContent
                              content={item}
                              style={{
                                fontSize: 12,
                                color: '#666666',
                                padding: 0,
                              }}
                            />
                            {/* <Text size={12} color={'#666666'} maxLine={3}>
                              {item}
                            </Text> */}
                          </div>
                        ))}
                      </Content>
                    </Collapse>
                  </div>
                </div>
              ) : null}

              {isRefundNotAllowed ? (
                <div style={{ marginTop: 80 }}>
                  <Title style={{ ...styles.subTitle }}>환불상품동의</Title>
                  <div>
                    <Collapse
                      title={
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 10,
                            padding: 10,
                          }}
                        >
                          <Checkbox
                            checked={isRefundAgree}
                            onClick={(e) => {
                              e.stopPropagation();
                              setIsRefundAgree(e.target.checked);
                            }}
                          />
                          <Text color={'#D33444'}>[필수]</Text>
                          <Text>환불불가상품 안내사항</Text>
                        </div>
                      }
                      defaultOpened={true}
                    >
                      <Content
                        maxWidth={'100%'}
                        style={{
                          borderBottom: '1px solid var(--light-gray-color)',
                          display: 'flex',
                          flexDirection: 'column',
                          gap: 8,
                        }}
                      >
                        {REFUND_INFO.map((item) => (
                          <div style={{ display: 'flex' }}>
                            <Text size={12} color={'#666666'}>
                              •
                            </Text>
                            <HtmlContent
                              content={item}
                              style={{
                                fontSize: 12,
                                color: '#666666',
                                padding: 0,
                              }}
                            />
                            {/* <Text size={12} color={'#666666'} maxLine={3}>
                              {item}
                            </Text> */}
                          </div>
                        ))}
                      </Content>
                    </Collapse>
                  </div>
                </div>
              ) : null}
              {/* 주문동의 끝 */}
            </Col>

            <Col x={24} md={8} xl={6}>
              <Content
                maxWidth={'100%'}
                padding={0}
                style={{ marginTop: top, position: 'sticky', top: 165 }}
              >
                <div
                  style={{
                    border: '3px solid var(--black-color)',
                    padding: 40,
                  }}
                >
                  <div
                    style={{
                      paddingBottom: 20,
                      borderBottom: '1px solid var(--light-gray-color)',
                    }}
                  >
                    <Text size={18} weight={700}>
                      결제금액
                    </Text>
                  </div>

                  <ul
                    style={{
                      padding: '20px 0px',
                      borderBottom: '1px solid var(--light-gray-color)',
                    }}
                  >
                    <li style={{ ...styles.orderInfo }}>
                      <Text size={16}>총 상품 금액</Text>
                      <Text size={16} weight={700}>
                        {type !== 'rental'
                          ? stringToMoneyFormat(
                              paymentInfo.total_origin_price,
                              '원'
                            )
                          : stringToMoneyFormat(
                              orderList?.[0]?.product_information?.[0]
                                ?.product_final_price,
                              '원'
                            )}
                      </Text>
                    </li>
                    {type === 'rental' ? (
                      <>
                        <li style={{ ...styles.orderInfo }}>
                          <Text style={styles.orderInfoText}>추가비용</Text>
                          <Text style={styles.orderInfoText} weight={700}>
                            {stringToMoneyFormat(
                              paymentInfo.additional_cost,
                              '원'
                            )}
                          </Text>
                        </li>
                        <li style={{ ...styles.orderInfo }}>
                          <Text style={styles.orderInfoText}>선납금</Text>
                          <Text style={styles.orderInfoText} weight={700}>
                            {stringToMoneyFormat(
                              paymentInfo.advance_price,
                              '원'
                            )}
                          </Text>
                        </li>
                      </>
                    ) : null}
                    <li style={{ ...styles.orderInfo }}>
                      <Text style={styles.orderInfoText}>등급 할인 금액</Text>
                      <Text
                        style={styles.orderInfoText}
                        weight={700}
                        color={'var(--danger-color)'}
                      >
                        -
                        {stringToMoneyFormat(
                          paymentInfo.total_grade_discount_price,
                          '원'
                        )}
                      </Text>
                    </li>
                    <li style={{ ...styles.orderInfo }}>
                      <Text style={styles.orderInfoText}>
                        프로모션 할인 금액
                      </Text>
                      <Text
                        style={styles.orderInfoText}
                        weight={700}
                        color={'var(--danger-color)'}
                      >
                        -
                        {stringToMoneyFormat(
                          paymentInfo.total_promotion_discount_price,
                          '원'
                        )}
                      </Text>
                    </li>
                    <li style={{ ...styles.orderInfo }}>
                      <Text style={styles.orderInfoText}>쿠폰 할인 금액</Text>
                      <Text
                        style={styles.orderInfoText}
                        weight={700}
                        color={'var(--danger-color)'}
                      >
                        -
                        {stringToMoneyFormat(
                          paymentInfo.total_coupon_discount_price,
                          '원'
                        )}
                      </Text>
                    </li>
                    <li style={{ ...styles.orderInfo }}>
                      <Text style={styles.orderInfoText}>사용 포인트</Text>
                      <Text style={styles.orderInfoText} weight={700}>
                        -{stringToMoneyFormat(usePoint, 'P')}
                      </Text>
                    </li>
                    <li style={{ ...styles.orderInfo }}>
                      <Text style={styles.orderInfoText}>배송비</Text>
                      <Text style={styles.orderInfoText} weight={700}>
                        {stringToMoneyFormat(
                          paymentInfo.total_delivery_price +
                            paymentInfo.total_remote_delivery_price,
                          '원'
                        )}
                      </Text>
                    </li>
                    <li style={{ ...styles.orderInfo, marginBottom: 0 }}>
                      <Text style={styles.orderInfoText}>적립 예상 금액</Text>
                      <Text style={styles.orderInfoText} weight={700}>
                        {stringToMoneyFormat(
                          paymentInfo.total_reserve_price,
                          '원'
                        )}
                      </Text>
                    </li>
                  </ul>

                  <div
                    style={{
                      paddingTop: 20,
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                  >
                    <Text size={screenSize >= 1200 ? 18 : 16} weight={700}>
                      총 결제 금액
                    </Text>
                    <Text
                      size={screenSize >= 1200 ? 28 : 20}
                      weight={700}
                      color={'var(--danger-color)'}
                    >
                      {type !== 'rental'
                        ? stringToMoneyFormat(
                            paymentInfo.total_final_price - usePoint,
                            '원'
                          )
                        : stringToMoneyFormat(
                            orderList?.[0]?.product_information?.[0]
                              ?.product_final_price +
                              paymentInfo?.additional_cost +
                              paymentInfo?.advance_price,
                            '원'
                          )}
                    </Text>
                  </div>
                </div>

                <div style={{ marginTop: 20 }}>
                  <Checkbox
                    style={{ ...styles.checkbox }}
                    checked={isChecked}
                    onChange={(e) => setIsChecked(e.target.checked)}
                  >
                    주문정보 및 서비스 이용약관에 동의합니다.
                  </Checkbox>
                </div>

                <div style={{ marginTop: 40 }}>
                  <Button
                    style={{ ...styles.orderButton }}
                    className="dela-gothic"
                    onClick={() => onPayment(type, selectedPaymentMethod)}
                  >
                    Order
                  </Button>
                </div>
              </Content>
            </Col>
            <Col x={0} md={1} xl={2}></Col>
          </Row>
        </Content>
      </Spin>

      {/* SECTION: 쿠폰 */}
      <ModalLayout
        open={isDrawer}
        onCancel={() => drawerClose()}
        width={500}
        centered
        closable
        title={'보유쿠폰'}
        styles={{
          content: {
            padding: 0,
          },
          header: {
            padding: '12px 24px',
            borderBottom: '1px solid #DDDDDD',
          },
        }}
      >
        <Content maxWidth={'100%'} padding={0}>
          <Row>
            <Col x={24}>
              <Content maxWidth={'100%'} padding={'12px 21px'}>
                <ScrollLayout
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 10,
                    height:
                      screenSize >= 768
                        ? ((document.body.clientWidth * 9) / 16) * 0.5
                        : '60vh',
                  }}
                >
                  {drawerCoupon.length ? (
                    drawerCoupon.map((coupon) => (
                      <div
                        style={{
                          background:
                            selectedCoupon &&
                            selectedCoupon.coupon_user_id ===
                              coupon.coupon_user_id
                              ? '#111111'
                              : '#FFFFFF',
                          padding: 3,
                          borderRadius: 8,
                        }}
                      >
                        <div
                          key={`coupon-${coupon.coupon_user_id}`}
                          style={{
                            border: '1px solid #DDDDDD',
                            borderRadius: 8,
                            cursor: 'pointer',
                            width: '100%',
                            position: 'relative',
                            top: 0,
                            left: 0,
                            background: '#FFFFFF',
                          }}
                          onClick={
                            coupon.is_available === 'DONE'
                              ? () => handleCouponClick(coupon)
                              : () => {}
                          }
                        >
                          <div
                            style={{
                              padding: 8,
                              borderBottom: '1px solid #DDDDDD',
                              position: 'relative',
                              top: 0,
                              right: 0,
                            }}
                          >
                            <Flex gap={4} align="center">
                              <Text
                                size={18}
                                weight={700}
                                style={{ cursor: 'pointer' }}
                              >
                                {stringToMoneyFormat(
                                  coupon.discount_price,
                                  '원'
                                )}{' '}
                                할인
                              </Text>

                              <Text
                                size={14}
                                weight={700}
                                style={{ cursor: 'pointer' }}
                              >
                                /
                              </Text>

                              <Text
                                size={18}
                                weight={700}
                                style={{ cursor: 'pointer' }}
                              >
                                {stringToMoneyFormat(
                                  coupon.reserve_price,
                                  '원'
                                )}{' '}
                                적립
                              </Text>
                            </Flex>

                            {coupon.apply_product &&
                            coupon.apply_product.key === selectedProduct.key ? (
                              <span
                                style={{
                                  position: 'absolute',
                                  top: '50%',
                                  right: 8,
                                  transform: 'translateY(-50%)',
                                  padding: '3px 5px',
                                  fontSize: 12,
                                  background: '#DDDDDD',
                                  borderRadius: 4,
                                }}
                                onClick={(e) => {
                                  setSelectedCoupon(null);
                                  onApplyCoupon(drawerClose);
                                  e.stopPropagation();
                                }}
                              >
                                적용 취소
                              </span>
                            ) : null}
                          </div>

                          <Flex
                            vertical
                            gap={12}
                            style={{
                              padding: 8,
                            }}
                          >
                            <Text
                              size={16}
                              weight={500}
                              style={{ cursor: 'pointer' }}
                            >
                              {coupon.policy_coupon.coupon_name}
                            </Text>

                            <Flex vertical gap={4}>
                              <Flex gap={8} align="center">
                                {[
                                  ...(coupon.policy_coupon.discount_rate > 0
                                    ? [
                                        {
                                          title: '할인',
                                          rate: coupon.policy_coupon
                                            .discount_rate,
                                          unit: RATE_TYPE[
                                            coupon.policy_coupon.discount_type
                                          ],
                                        },
                                      ]
                                    : []),

                                  ...(coupon.policy_coupon.reserve_rate > 0
                                    ? [
                                        {
                                          title: '적립',
                                          rate: coupon.policy_coupon
                                            .reserve_rate,
                                          unit: RATE_TYPE[
                                            coupon.policy_coupon.reserve_type
                                          ],
                                        },
                                      ]
                                    : []),
                                  {
                                    title: '최대할인',
                                    rate: coupon.policy_coupon
                                      .max_discount_price,
                                    unit: '원',
                                  },
                                ].map((item, index) => (
                                  <React.Fragment key={`rate_info_${index}`}>
                                    {index ? (
                                      <Text
                                        size={10}
                                        style={{ cursor: 'pointer' }}
                                        color={'#666666'}
                                      >
                                        /
                                      </Text>
                                    ) : null}
                                    <Text
                                      size={14}
                                      style={{ cursor: 'pointer' }}
                                    >
                                      {item.title}:{' '}
                                      {stringToMoneyFormat(
                                        item.rate,
                                        item.unit
                                      )}
                                    </Text>
                                  </React.Fragment>
                                ))}
                              </Flex>

                              <Flex justify="space-between" align="flex-end">
                                <Text size={14} style={{ cursor: 'pointer' }}>
                                  만료일:{' '}
                                  {Formatter.unixToDate(
                                    coupon.expired_date,
                                    'YYYY.MM.DD'
                                  )}
                                </Text>

                                {coupon.policy_coupon.is_duplication === 'N' ? (
                                  <Text size={12} color={'#999999'}>
                                    중복적용 불가
                                  </Text>
                                ) : null}
                              </Flex>
                            </Flex>
                          </Flex>

                          {coupon.is_available === 'DONE' ? null : (
                            <div
                              style={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                width: '100%',
                                height: '100%',
                                borderRadius: 8,
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                backdropFilter: 'blur(3px)',
                                zIndex: 10,
                                cursor: 'default',
                              }}
                            >
                              <Flex
                                justify="center"
                                align="center"
                                style={{
                                  width: '100%',
                                  height: 36,
                                  position: 'absolute',
                                  bottom: 0,
                                  left: 0,
                                  background: 'rgba(0, 0, 0, 0.7)',
                                  textAlign: 'center',
                                  borderBottomLeftRadius: 8,
                                  borderBottomRightRadius: 8,
                                }}
                              >
                                <Text size={12} weight={700} color={'#FFFFFF'}>
                                  {getReason(coupon.is_available, coupon)}
                                </Text>
                              </Flex>
                            </div>
                          )}
                        </div>
                      </div>
                    ))
                  ) : (
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '100%',
                        height: '100%',
                      }}
                    >
                      <Empty description={'사용 가능한 쿠폰이 없습니다.'} />
                    </div>
                  )}
                </ScrollLayout>
              </Content>
            </Col>
            <Col x={24}>
              <Content maxWidth={'100%'} padding={0}>
                <Button
                  style={{ width: '100%', borderRadius: 0 }}
                  onClick={() => onApplyCoupon(drawerClose)}
                >
                  적용하기
                </Button>
              </Content>
            </Col>
          </Row>
        </Content>
      </ModalLayout>

      {/* SECTION: 스토어픽업 지도 */}
      <ModalLayout
        closable
        open={!!isPickupModal}
        onCancel={() => setIsPickupModal(null)}
        width={screenSize >= 768 ? '30%' : '100%'}
        centered
        title={isPickupModal?.forwarding_name}
        styles={{
          content: {
            padding: 0,
          },
          header: {
            padding: '12px 24px',
            borderBottom: '1px solid #DDDDDD',
          },
        }}
      >
        <Content maxWidth={'100%'} padding={0}>
          <Row>
            <Col x={24}>
              <Content maxWidth={'100%'} padding={'12px 21px'}>
                <div>
                  <ul style={{ display: 'flex' }}>
                    <li
                      style={{
                        padding: '12px 24px',
                        background: mapKey === 'MAP' ? '#111111' : '#FFFFFF',
                        border: '1px solid #111111',
                        cursor: 'pointer',
                      }}
                      onClick={() => setMapKey('MAP')}
                    >
                      <Text color={mapKey === 'MAP' ? '#FFFFFF' : '#111111'}>
                        지도
                      </Text>
                    </li>
                    {isPickupModal?.receive_information?.pickup_location_map ? (
                      <li
                        style={{
                          padding: '12px 24px',
                          background:
                            mapKey === 'ROUGH' ? '#111111' : '#FFFFFF',
                          border: '1px solid #111111',
                          cursor: 'pointer',
                        }}
                        onClick={() => setMapKey('ROUGH')}
                      >
                        <Text
                          color={mapKey === 'ROUGH' ? '#FFFFFF' : '#111111'}
                        >
                          약도
                        </Text>
                      </li>
                    ) : null}
                  </ul>
                  <div style={{ border: '1px solid #111111' }}>
                    {mapKey === 'MAP' ? (
                      <KakaoMap
                        name={isPickupModal?.forwarding_name}
                        address={`${isPickupModal?.forwarding_address}`}
                        width={'100%'}
                        height={340}
                      />
                    ) : (
                      <Img
                        src={`${STORE_URL}/${isPickupModal?.receive_information?.pickup_location_map}`}
                        width={'100%'}
                        height={340}
                        style={{ objectFit: 'contain' }}
                      />
                    )}
                  </div>

                  <ul
                    style={{
                      marginTop: 20,
                      display: 'flex',
                      flexDirection: 'column',
                      gap: 10,
                    }}
                  >
                    <li style={{ display: 'flex' }}>
                      <div style={{ width: 80 }}>
                        <Text size={14} weight={700}>
                          영업시간
                        </Text>
                      </div>
                      <div>
                        <Text size={14}>
                          {isPickupModal?.receive_information?.business_hour}
                        </Text>
                      </div>
                    </li>

                    <li style={{ display: 'flex' }}>
                      <div style={{ width: 80 }}>
                        <Text size={14} weight={700}>
                          전화
                        </Text>
                      </div>
                      <div>
                        <Text size={14}>{isPickupModal?.phone}</Text>
                      </div>
                    </li>

                    <li style={{ display: 'flex' }}>
                      <div style={{ width: 80 }}>
                        <Text size={14} weight={700}>
                          주소
                        </Text>
                      </div>
                      <div>
                        <Text size={14} style={{ webkitLineClamp: 'unset' }}>
                          {isPickupModal?.forwarding_address},{' '}
                          {isPickupModal?.forwarding_address_detail}
                        </Text>
                      </div>
                    </li>

                    <li style={{ display: 'flex' }}>
                      <div style={{ width: 80 }}>
                        <Text size={14} weight={700}>
                          담당자
                        </Text>
                      </div>
                      <div>
                        <Text size={14}>
                          {isPickupModal?.receive_information?.manager_name}
                        </Text>
                      </div>
                    </li>

                    {isPickupModal?.receive_information
                      ?.pickup_available_date ? (
                      <li style={{ display: 'flex' }}>
                        <div style={{ width: 80 }}>
                          <Text size={14} weight={700}>
                            수령 가능일
                          </Text>
                        </div>
                        <div>
                          <Text size={14}>
                            {isPickupModal?.receive_information
                              ?.pickup_available_date === 0
                              ? '당일수령가능'
                              : `주문 완료 시점부터 ${isPickupModal?.receive_information?.pickup_available_date}일 부터 수령 가능일자가 표시됩니다.`}
                          </Text>
                        </div>
                      </li>
                    ) : null}

                    <li style={{ display: 'flex' }}>
                      <div style={{ width: 80 }}>
                        <Text size={14} weight={700}>
                          수령지 안내
                        </Text>
                      </div>
                      <div>
                        <Text size={14}>
                          {
                            isPickupModal?.receive_information
                              ?.pickup_instruction
                          }
                        </Text>
                      </div>
                    </li>
                  </ul>
                </div>
              </Content>
            </Col>
          </Row>
        </Content>
      </ModalLayout>
    </React.Fragment>
  );
};

export default OrderOrderPresenter;
